<template lang="pug">
  .view-index.container
    .content
      h1 Index page
</template>

<script>
export default {
  name: 'view-index',

  data: () => ({}),

  beforeRouteEnter(to, from, next) {
    next(vm => {
      const user = vm.$store.getters.user;
      return vm.$router.replace({ name: user.isAdmin ? 'control.reports' : 'app.tests' });
    });
  },
};
</script>
